"use strict";

var BadgeVariants = /* @__PURE__ */(BadgeVariants2 => {
  BadgeVariants2["lighterGreen"] = "lighterGreen";
  BadgeVariants2["lightGreen"] = "lightGreen";
  BadgeVariants2["green"] = "green";
  BadgeVariants2["lightBlue"] = "lightBlue";
  BadgeVariants2["blue"] = "blue";
  BadgeVariants2["yellow"] = "yellow";
  BadgeVariants2["lightGrey"] = "lightGrey";
  BadgeVariants2["grey"] = "grey";
  BadgeVariants2["lightNavy"] = "lightNavy";
  BadgeVariants2["darkBlueMagenta"] = "darkBlueMagenta";
  BadgeVariants2["syrahSoil"] = "syrahSoil";
  BadgeVariants2["linearCatalinaBlue"] = "linearCatalinaBlue";
  BadgeVariants2["linearSunsetFlame"] = "linearSunsetFlame";
  BadgeVariants2["rubyRed"] = "rubyRed";
  BadgeVariants2["lightAquaBlue"] = "lightAquaBlue";
  BadgeVariants2["wizardWhite"] = "wizardWhite";
  return BadgeVariants2;
})(BadgeVariants || {});
export { BadgeVariants };
//# sourceMappingURL=Badge.types.mjs.map
